import { FC } from "react";
import { GatewayProvider as InternalGatewayProvider } from "@civic/solana-gateway-react";
import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { SOLANA_ENDPOINT } from "../../solana/common/utilities";
import logo from "../../assets/uniqueLogoBlack.svg";
import { gatewayStore } from "../../contexts/gatewayStore";

const env = {
  clusterUrl: SOLANA_ENDPOINT,
  cluster: SOLANA_ENDPOINT.includes("devnet") ? "devnet" : "mainnet",
};

const GatewayProvider: FC = ({ children }) => {
  const { gatekeeperNetwork } = gatewayStore();

  const wallet = useAnchorWallet();
  const { cluster, clusterUrl } = env;

  return (
    <InternalGatewayProvider
      wallet={wallet}
      logo={logo}
      gatekeeperNetwork={gatekeeperNetwork}
      clusterUrl={clusterUrl}
      cluster={cluster}
      options={{ autoShowModal: false }}
    >
      {children}
    </InternalGatewayProvider>
  );
};

export default GatewayProvider;
